import PropTypes from 'prop-types';
import {userType} from 'propTypes/accounts';

export const workLogsType = PropTypes.shape({
    isLoading: PropTypes.bool.isRequired,
    error: PropTypes.string,
    activeGroups: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number.isRequired,
        start_time: PropTypes.string.isRequired,
        end_time: PropTypes.string,
        work_logs: PropTypes.arrayOf(PropTypes.shape({
            user: userType.isRequired,
            product: PropTypes.number.isRequired,
        })).isRequired,
    })).isRequired,
    groups: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number.isRequired,
        start_time: PropTypes.string.isRequired,
        end_time: PropTypes.string,
        work_logs: PropTypes.arrayOf(PropTypes.shape({
            user: userType.isRequired,
            product: PropTypes.number.isRequired,
        })).isRequired,
    })).isRequired,
});

export const feedbackType = PropTypes.shape({
    id: PropTypes.number.isRequired,
    status: PropTypes.string.isRequired,
    status_label: PropTypes.string.isRequired,
    comment: PropTypes.string.isRequired,
    product_status: PropTypes.string.isRequired,
    product_status_label: PropTypes.string.isRequired,
    quality_assurance_officer: userType.isRequired,
});

export const qualityControlType = PropTypes.shape({
    isLoading: PropTypes.bool.isRequired,
    feedback: PropTypes.arrayOf(feedbackType),
});

export const activeWorkLogGroupType = PropTypes.shape({
    id: PropTypes.number.isRequired,
    owner: PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
    }).isRequired,
    start_time: PropTypes.string.isRequired,
    end_time: PropTypes.string,
    work_logs: PropTypes.arrayOf(PropTypes.shape({
        user: PropTypes.shape({
            id: PropTypes.number.isRequired,
            name: PropTypes.string.isRequired,
        }).isRequired,
        product: PropTypes.number.isRequired,
    })).isRequired,
});

export const productType = PropTypes.shape({
    article_code: PropTypes.string,
    article_name: PropTypes.string,
    welder: userType,
    order: PropTypes.shape({
        client_name: PropTypes.string,
        extras: PropTypes.string,
        fastening: PropTypes.string,
        info: PropTypes.string,
        quality_check_required: PropTypes.bool,
        status_display: PropTypes.string.isRequired,
        transport: PropTypes.string,
        width: PropTypes.string,
    }).isRequired,
    estimated_duration: PropTypes.number,
    actual_welding_time: PropTypes.number.isRequired,
    quality_control_feedback: PropTypes.arrayOf(feedbackType).isRequired,
    previous_statuses: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
    })).isRequired,
    active_worklog: PropTypes.shape({
        in_progress: PropTypes.bool.isRequired,
        user_id: PropTypes.number,
    }).isRequired,
    is_batch_welding_finished: PropTypes.bool.isRequired,
});



// WEBPACK FOOTER //
// ./src/propTypes/products.js